import { http } from '@/shared/api';
import type { components } from '@/shared/api/schema';

export type FxRate = components['schemas']['FxRateResponse'];
export type CommercialFxRates = components['schemas']['CommercialFxRatesResponse'];
export type CommercialFxRate = components['schemas']['CommercialFxRateItem'];

export function getFxRates(): Promise<FxRate[]> {
  return http<FxRate[]>('/fx-rates');
}

export function getCommercialFxRates(): Promise<CommercialFxRates> {
  return http<CommercialFxRates>('/fx-rates/commercial');
}
